<ng-container *transloco="let t">
<div class="learning-content">
    <img [tuiSkeleton]="skeleton" class="img-text tui-space_top-5 tui-space_bottom-1 skeleton-img" (load)="this.skeleton = false;"
        src="{{environment.assertsUrl}}i/banner.jpg">
    <h4 class="tui-text_h4 tui-space_top-5 tui-space_bottom-6">
        {{ t('learning.title') }}
    </h4>
    <p class="text tui-space_bottom-3">{{ t('learning.intro.paragraph1') }}</p>
    <p class="text tui-space_bottom-3">{{ t('learning.intro.paragraph2') }}</p>
    <p class="text tui-space_bottom-3">{{ t('learning.intro.paragraph3') }}</p>
    <p class="text tui-space_bottom-3">{{ t('learning.intro.paragraph4') }}</p>
    <p class="text tui-space_bottom-3">{{ t('learning.intro.paragraph5') }}</p>
</div>
<tui-accordion class="tui-space_top-5 tui-space_bottom-5">
    <button tuiAccordion>{{ t('learning.accordion.whyKnow') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">
            {{ t('learning.accordion.whyKnowContent.intro') }}
        </p>

        <ul class="tui-list tui-list_large">
            <li class="tui-list__item" *ngFor="let benefit of t('learning.accordion.whyKnowContent.benefits')">
                <b>{{ benefit.title }}</b><br>
                {{ benefit.description }}
            </li>
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('learning.accordion.ericBerne') }}</button>
    <tui-expand>
    <p class="text tui-space_bottom-3">{{ t('learning.accordion.ericBerneContent.intro') }}</p>
    <img [tuiSkeleton]="skeletonBerne" class="tui-space_top-5 tui-space_bottom-1 img-text-berne" (load)="this.skeletonBerne = false;" src="{{environment.assertsUrl}}main/berne.jpg">
    <p class="text tui-space_bottom-3"><i>{{ t('learning.accordion.ericBerneContent.quote') }}</i></p>
    <p class="text tui-space_bottom-3"><b>{{ t('learning.accordion.ericBerneContent.definition') }}</b></p>
    <p class="text tui-space_bottom-3">{{ t('learning.accordion.ericBerneContent.observation') }}</p>
    <p class="text tui-space_bottom-3">{{ t('learning.accordion.ericBerneContent.patterns') }}</p>
    <p class="text tui-space_bottom-3">{{ t('learning.accordion.ericBerneContent.egoStates') }}</p>
    <ul class="tui-list tui-list_large">
        <li class="tui-list__item" *ngFor="let classification of t('learning.accordion.ericBerneContent.classifications')">{{ classification }}</li>
    </ul>
    <p class="text tui-space_bottom-3">{{ t('learning.accordion.ericBerneContent.conclusion') }}</p>
    </tui-expand>
</tui-accordion> 
<h5 class="tui-text_h5 tui-space_top-5 tui-space_bottom-5">
    {{ t('learning.readAbout') }}
</h5>
<form tuiGroup class="group" [collapsed]="true" [formGroup]="formRoute">
    <label appearance="" tuiBlock="s">
        <input formControlName="page" tuiBlock="s" type="radio" [value]="ROUTES_CONST.PARENT_LEARN" />
        {{ t('learning.egoStates.parent') }}
    </label>
    <label appearance="" tuiBlock="s">
        <input formControlName="page" tuiBlock="s" type="radio" [value]="ROUTES_CONST.ADULT_LEARN" />
        {{ t('learning.egoStates.adult') }}
    </label>
    <label appearance="" tuiBlock="s">
        <input formControlName="page" tuiBlock="s" type="radio" [value]="ROUTES_CONST.CHILD_LEARN" />
        {{ t('learning.egoStates.child') }}
    </label>
</form>
<div class="content">
    <router-outlet></router-outlet>
</div>
</ng-container>